import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/OfertaReducer/actions'
import * as Notifications from '../../components/Common/notification'
import * as layoutActions from '../../reducers/layoutReducer/actions'

function* genGetOfertasActivas(e) {
  try {
    // llamo a la acción que trae las ofertas
    let ofertas = yield calls.GetOfertasActivas()
    yield put(reducerActions.setOferta(ofertas))
  } catch (error) {
    if (error.Message) {
      return
    }
  }
}

function* genGetOfertas(e) {
  try {
    yield put(
      layoutActions.setLoading({ show: true, message: 'Obteniendo ofertas' })
    )
    // llamo a la acción que trae las ofertas
    let ofertas = yield calls.getOfertas()

    yield put(reducerActions.setOferta(ofertas))
  } catch (error) {
    if (error.Message) {
      return
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }))
  }
}
/*
function* genGetOfertaById(e){
    try {

        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo oferta seleccionada' }))
        // llamo a la acción que trae la oferta
        let oferta = yield calls.getOfertaById(e.payload)
        
        yield put(reducerActions.setOfertaById(oferta))
    }
    catch (error) 
    {
        if (error.Message) {
            
            return;
        }
    }
    finally{
      yield put(layoutActions.setLoading({ show: false}))
    }
}
*/

// Editar oferta
function* genPutOferta(e) {
  try {
    let callback = e.payload.callback
    e.payload.callback = undefined
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Guardando oferta editada',
      })
    )
    // llamo a la acción que trae las ofertas

    yield calls.putOferta(e.payload)

    if (callback !== undefined) {
      callback()
    }

    Notifications.showSuccess('Oferta guardada con éxito')
  } catch (error) {
    if (error.Message) {
      return
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genBorrarOferta(e) {
  try {
    yield put(
      layoutActions.setLoading({ show: true, message: 'Borrando oferta' })
    )
    // llamo a la acción que trae las ofertas
    yield calls.borrarOferta(e.payload)

    yield put(reducerActions.setOfertaInactivo(e.payload))

    Notifications.showSuccess('Oferta eliminada')
  } catch (error) {
    if (error.Message) {
      return
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genSaveOferta(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Guardando oferta' })
    )
    // llamo a la acción que trae las ofertas
    let result = yield calls.saveOferta(e.payload)

    if (result === '') {
      if (e.payload.idOferta === undefined) {
        Notifications.showSuccess('Oferta creada')
        let callback = e.payload.callback
        e.payload.callback = undefined
        if (callback !== undefined) {
          callback()
        }
      } else if (e.payload.idOferta !== null) {
        Notifications.showSuccess('Oferta actualizada ')
        e.history.goBack()
      }
    } else {
      Notifications.showError(result)
    }
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genSwapOferta(e) {
  try {
    //yield put(layoutActions.setLoading({ show: true, message: 'Cambiando orden de ofertas' }))
    // llamo a la acción que trae las ofertas
    let ofertas = yield calls.swapOferta(e.payload)

    yield put(reducerActions.setOferta(ofertas))

    Notifications.showSuccess('Oferta desplazada ')
  } catch (error) {
    if (error.Message) {
      return
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_OFERTAS, genGetOfertas),
    takeLatest(reducerActions.SAGA_GET_OFERTAS_ACTIVAS, genGetOfertasActivas),
    //takeLatest(reducerActions.SAGA_GET_OFERTASBYID, genGetOfertaById),
    takeLatest(reducerActions.SAGA_BORRAR_OFERTA, genBorrarOferta),
    takeLatest(reducerActions.SAGA_SAVE_OFERTA, genSaveOferta),
    takeLatest(reducerActions.SAGA_SWAP_OFERTA, genSwapOferta),
    takeLatest(reducerActions.SAGA_PUT_OFERTA, genPutOferta),
  ])
}

export const sagas = [defaultSaga]
